module.exports = __webpack_public_path__ + "app-static/img/02.6c8e2b27.jpg";